import { render, staticRenderFns } from "./appSkin.vue?vue&type=template&id=e670f5cc&scoped=true"
import script from "./appSkin.vue?vue&type=script&lang=js"
export * from "./appSkin.vue?vue&type=script&lang=js"
import style0 from "./appSkin.vue?vue&type=style&index=0&id=e670f5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e670f5cc",
  null
  
)

export default component.exports